import { useQuery } from "@tanstack/react-query";
import { getBarometerData } from "../services/grantsApi";
import { BarometerResponse } from "../types/grants";

/**
 * Hook for fetching labour barometer data for given district codes.
 * Returns deficit professions grouped by district with voivodeship-level data.
 *
 * Only fetches when districtCodes is non-empty. Uses 24h stale time
 * (data changes rarely - annual GUS publication).
 *
 * @param districtCodes - Array of TERYT 4-digit district codes
 * @param options.enabled - Additional condition to enable the query (default: true)
 * @returns Query result with barometer data
 * @see docs/specifications/2026-03-06-kfs-barometr-zawodow.md
 */
export function useBarometer(
  districtCodes: string[],
  options?: { enabled?: boolean }
) {
  const enabled =
    (options?.enabled ?? true) && districtCodes.length > 0;

  return useQuery<BarometerResponse>({
    queryKey: ["grants-barometer", ...districtCodes.sort()],
    queryFn: () => getBarometerData(districtCodes),
    enabled,
    staleTime: 24 * 60 * 60 * 1000, // 24h - barometer data is annual
    retry: 1, // Single retry on failure, then graceful hide
  });
}
